import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2, Lock } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/logo-black.png" alt="Nettoyage Expert" className="h-16 mx-auto mb-4" />
          <h1 className="text-xl font-bold text-slate-900" data-testid="login-title">Administration</h1>
          <p className="text-sm text-slate-500 mt-1">Connectez-vous pour accéder au back-office</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm space-y-4" data-testid="login-form">
          {error && (
            <div className="bg-red-50 text-red-700 text-sm px-4 py-2.5 rounded-md border border-red-200" data-testid="login-error">
              {error}
            </div>
          )}
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1">Email</label>
            <input
              id="email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#336DBF] focus:border-transparent"
              placeholder="admin@nettoyage-expert.ch"
              data-testid="login-email"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-slate-700 mb-1">Mot de passe</label>
            <input
              id="password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#336DBF] focus:border-transparent"
              placeholder="••••••••"
              data-testid="login-password"
            />
          </div>
          <button
            type="submit" disabled={loading}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-[#336DBF] text-white text-sm font-semibold rounded-md hover:bg-[#2A5A9E] disabled:opacity-60 transition-colors"
            data-testid="login-submit"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
        <p className="text-center text-xs text-slate-400 mt-6">Nettoyage Expert — Administration</p>
      </div>
    </div>
  );
}
